import * as Icons from "@reverb-ui/icons-react";
import { Box, HStack,Text, VStack} from "@reverb-ui/react";

export interface IInformationMessage {
    iconTitle?: string,
    messageText: any,
  }

  const InformationMessage: React.FC<IInformationMessage> = ({
    iconTitle = 'Chat',
    messageText,
  }) => {

      // @ts-ignore: Unreachable code error
    const Icon = Icons[iconTitle];
    
    return (
        <Box
        background= "#EDF1F7"
        width="100%"
        justifyContent="flex-start"
        padding="0.625rem"
        borderRadius="0.188rem"
        >
            <VStack>
                <HStack display="flex" justifyContent="flex-start" width="full">
                    <Icon color="gray.400" size="md" />
                    <Text color="gray.800" fontSize="12px">{messageText}</Text>
                </HStack>
            </VStack>
        </Box>
    )
  }

  export default InformationMessage